import { tv } from "tailwind-variants";
const tabsStyles = tv({
  slots: {
    childrenStyles: "",
    subTitleStyles: "text-b3",
    list: "flex w-fit items-center justify-center gap-2 p-1 overflow-hidden",
    labelContainer: "flex flex-col group group-data-[state=active]:text-inherit",
    trigger: `inline-flex items-center justify-center whitespace-nowrap transition-all 
      focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 
      disabled:cursor-pointer text-t3 font-bold text-slate-500 py-2 px-3`,
    content: "opacity-0 ring-offset-white duration-500 data-[state=active]:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
  },
  variants: {
    variant: {
      solid: {
        list: "rounded-full bg-slate-50",
        trigger: "rounded-full gap-2 data-[state=active]:bg-blue data-[state=active]:text-white"
      },
      glassy: {
        list: "bg-white",
        trigger: "rounded-lg gap-1 flex-col data-[state=active]:bg-blue-100 data-[state=active]:text-blue"
      },
      underline: {
        list: "bg-white border-b border-blue-200 gap-5 p-0",
        trigger: "data-[state=active]:border-b-blue data-[state=active]:text-blue border-b-2 border-transparent min-w-9 justify-start py-4 gap-2"
      },
      enclosed: {
        list: "bg-slate-100 rounded-lg gap-1",
        trigger: "group data-[state=active]:bg-white data-[state=active]:shadow-sm data-[state=active]:rounded-lg data-[state=active]:text-blue flex-col"
      }
    },
    icon: { true: {} },
    subTitle: { true: {} },
    children: { true: {} }
  },
  compoundVariants: [
    {
      icon: true,
      variant: "underline",
      class: { trigger: "min-w-16" }
    },
    {
      subTitle: true,
      variant: "underline",
      class: { trigger: "min-w-20" }
    },
    {
      icon: true,
      subTitle: true,
      variant: "underline",
      class: { trigger: "min-w-28" }
    },
    {
      subTitle: true,
      variant: "enclosed",
      class: { subTitleStyles: "!text-slate-500" }
    },
    {
      children: true,
      variant: "enclosed",
      class: {
        childrenStyles: "text-slate-900 group-data-[state=active]:text-inherit"
      }
    }
  ],
  defaultVariants: {
    icon: false,
    subTitle: false,
    variant: "solid"
  }
});
export {
  tabsStyles
};
